import {
    RoleTree,
    RoleTreeWithPermissions,
} from 'routes/Admin/UserManagement/Users/CreateOrEditUser/components/UserFormGeneralSection/components/types';

export const isRoleTreeWithPermissions = (
    roleTree: RoleTree | RoleTreeWithPermissions,
): roleTree is RoleTreeWithPermissions =>
    'permissions' in roleTree && Array.isArray(roleTree.permissions);
